import React, { Component, Fragment } from "react";
import { Row, Col } from 'react-bootstrap';
import { Modal } from "react-bootstrap";
import autoBind from "react-autobind";
import { ddados } from "../solicitarDocumento.ddados";
import DDadosItem from '@common/components/ddados/ddados.item';
import { connect } from "@common/components/base.component";
import solicitarDocumentoSelector from "../store/solicitarDocumento.selectors";
import solicitarDocumentoActions from "../store/solicitarDocumento.actions";
import Form from "@common/externos/components/validation/form.validation";
import StaticGrid from "@common/components/grid/staticGrid.component";
import Button from '@material-ui/core/Button';

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    const options = {
      filterVersion: Math.random(),
      noStorage: true,
      webStorage: "RedeSIM.SolicitarDocumento",
      applySearchOnLoad: true,
      isNotCheckable: true,
    };

    const columns = [
      {
        fieldName: "Protocolo",
        dataName: "NrProtocolo",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Tipo Documento",
        dataName: "TipoDocumento",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Solicitação",
        dataName: "DataSolicitacao",
        show: true,
        type: "date",
        removeFilter: true
      },
      {
        fieldName: "Situação",
        dataName: "SituacaoDocumento",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Novo",
        dataName: "SnNovo",
        show: true,
        type: "text",
        removeFilter: true
      },
    ];

    const actions = [];

    const order = [
      { fieldName: "Protocolo", dataName: "Protocolo", order: "A" }
    ];

    const toolbar = {
      title: "",
      prefix: " ",
      tools: {
        limpar: false
      }
    };

    this.config = {
      order,
      columns,
      actions,
      options,
      toolbar
    };
  }

  onClose(){
    this.props.solicitarDocumentoActions.resetSolicitacaoDocumentoPost();
    this.props.solicitarDocumentoActions.toggleModalResultadoDocumento();
    this.props.solicitarDocumentoActions.setGridSolicitarDocumento([]);
  }

  render() {
    const { solicitarDocumento } = this.props.solicitarDocumentoSelector;
    const { GridSolicitarDocumentoResultado } = solicitarDocumento;
    const { show } = this.props;

    return (
      <>
        <Modal
          className={"mt-5 mb-5"}
          show={show}
          onHide={this.onClose}
          enforceFocus={true}
          size="xl"
          backdrop="static"
        >
          <Modal.Header>
            <Modal.Title>
              <h3>Resultado</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <StaticGrid {...this.config} itens={GridSolicitarDocumentoResultado.asMutable()}></StaticGrid>
          </Modal.Body>
          <Modal.Footer>
           <p>Os Documentos onde a coluna "Novo" for igual a "Não" a solicitação do documento está pendente na prefeitura.</p>
              <Button variant="outlined" color="primary" onClick={this.onClose}>
                    <i className={"mr-1 fa fa-angle-double-left"} />{" "}
                    {"Voltar"}
              </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default connect({
  actions: {
    solicitarDocumentoActions
  },
  selectors: {
    solicitarDocumentoSelector
  }
})(Container);
